import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectCurrencyOptions = createSelector(
  [selectQbrState],
  (state) => state.documentSettings.currencyOptions
)
